import Cookies from 'js-cookie';
const checkStatus = response => {
	if (response.ok) {

		if (response.status === 200) {
			return response.json();
		} else {
			return { error: 'No data found' };
		}
		//return response;
	} else {
		// Incase token expired

		if (response.status === 401) {
			return response.json().then(res => {
				if (res.message === 'Token Not Valid.' || res.message === 'Token Expired') {
					//alert('Session Expired');
					console.log('Token Not Valid/Expired.')
					Cookies.set('userId', '');
					Cookies.set('token', '');
					//window.location.reload();
					window.location.href = "/";
					return;

				} else {
					console.log(res);
					return res;
				}

			}
			);

		} else {

			if (response.statusText !== '') {
				let errorText = '';
				if (response.statusText !== '') {
					errorText = response.statusText;
				} else {
					errorText = response.error;
				}
				const error = new Error(errorText);
				error.response = response;
				throw error;

			} else {
				return response.json();
			}
		}


	}
};

// const parseJSON = res => res.json();

const Fetcher = {
	get: (path, params) => {

		const token = Cookies.get('token');
		if (typeof params == 'undefined' || params === '') {
			params = {};
		}
		if (typeof token !== 'undefined') {
			params.headers = { 'Authorization': 'Bearer ' + token }
		}

		return fetch(path, params)
			.then(checkStatus)
		//.then( parseJSON )

	},

	post: (path, params) => {

		const token = Cookies.get('token');
		if (typeof params == 'undefined' || params === '') {
			params = {};
		}
		if (typeof params.headers == 'undefined') {
			params.headers = {};
		}

		// check for login request
		if (typeof params.headers.Authorization === 'undefined' && typeof token !== 'undefined') {
			params.headers['Authorization'] = 'Bearer ' + token;
		}

		return fetch(path, params)
			.then(checkStatus)
		//.then( parseJSON )
	},

};

export const fetchAndSetFlashMessage = (apiPath, filterFn1, setStateFn1, filterFn2 = null, setStateFn2 = null, userId = null) => {
    // With a userId, this resolves hierarchy-aware: a sub-superadmin's own message
    // for that module wins if they've set one, otherwise it falls back to
    // superadmin's global default. Without a userId it's the plain global list,
    // unchanged from before.
    const url = userId
        ? `${apiPath}/api/obd/get/flash/messages/${userId}`
        : `${apiPath}/api/obd/get/flash/messages`;
    Fetcher.get(url)
        .then(res => {
            const filteredMessage1 = res?.find(filterFn1);
            setStateFn1(filteredMessage1?.message ?? "");

            if (filterFn2 && setStateFn2) {
                const filteredMessage2 = res?.find(filterFn2);
                setStateFn2(filteredMessage2?.message ?? "");
            }
        })
        .catch(err => {
            console.error('Error fetching messages:', err);
        });
};
export { Fetcher };